<template>
  <div id="page-wrapper">
    <div class="row page-titles">
      <div class="col-md-5 align-self-center">
        <h3 class="text-themecolor">{{ $t('revenue.report') }}</h3>
      </div>
      <div class="col-md-7 align-self-center">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="javascript:void(0)">{{ $t('nav.home') }}</a></li>
          <li class="breadcrumb-item"><a href="javascript:void(0)">{{ $t('nav.revenue') }}</a></li>
          <li class="breadcrumb-item active">{{ $t('revenue.report') }}</li>
        </ol>
      </div>
    </div>
    <div class="container-fluid">
      <!-- /row -->
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <div class="card">
            <div class="card-header">
              <el-date-picker
                  v-model="dateRange"
                  slot="prepend"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  :range-separator="$t('contract.to')"
                  :start-placeholder="$t('contract.start-date')"
                  :end-placeholder="$t('contract.end-date')"
                  @change="filterList"
                  >
                </el-date-picker>
            </div>
            <div class="card-body">
              <div class="col-md-4 col-sm-6">
                <RevenueAccountBox :type="1" :balance="account.deposit" @show-detail="showDetail(1)" />
              </div>
              <div class="col-md-4 col-sm-6">
                <RevenueAccountBox :type="2" :balance="account.backout" @show-detail="showDetail(2)" />
              </div>
              <div class="col-md-4 col-sm-6">
                <RevenueAccountBox :type="3" :balance="account.non_operation" @show-detail="showDetail(3)" />
              </div>
              <div class="col-md-4 col-sm-6">
                <RevenueAccountBox :type="4" :balance="account.retained" @show-detail="showDetail(4)" />
              </div>
              <div class="col-md-4 col-sm-6">
                <RevenueAccountBox :type="5" :balance="account.operation" @show-detail="showDetail(5)" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 col-sm-12">
          <div class="card">
            <div class="card-header">
              <h3>{{ title }}</h3>
            </div>
            <div class="card-body">
              <div class="col-md-12 col-sm-12">
                <el-table
                    id="revenue-detail"
                    :data="currentData"
                    style="width: 100%"
                    :default-sort = "{prop: 'cashInDate', order: 'ascending'}"
                    >
                  <el-table-column
                    v-if="currentReport != 3"
                      prop="vacancy"
                      :label="$t('revenue.vacancy')"
                      width="220"
                      sortable>
                    </el-table-column>
                    <el-table-column
                      prop="legalEntityId"
                      :label="$t('revenue.legal-entity')"
                      width="150"
                      sortable
                      :filters="legalEntityFilter"
                            :filter-method="filterHandler">
                      <template slot-scope="scope">
                        {{ getLegalEntity(scope.row.legalEntityId) }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="cashInDate"
                      :label="$t('revenue.cashin-date')"
                      width="150"
                      sortable
                      >
                      <template slot-scope="scope">
                        {{ scope.row.cashInDate }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="value"
                      :label="$t('revenue.amount')"
                      width="150"
                      sortable
                      >
                      <template slot-scope="scope">
                        {{ scope.row.value | roundNum }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="comment"
                      :label="$t('revenue.comment')"
                      width="200"
                      sortable
                      >
                      <template slot-scope="scope">
                        {{ scope.row.comment }}
                      </template>
                    </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>
<script>
// @ is an alias to /src
import moment from 'moment'
import { Loading } from 'element-ui'
import RevenueAccountBox from '@/components/revenue/RevenueAccountBox.vue'

export default {
  name: 'revenue-account',
  props: ['message'],
  components: {
    RevenueAccountBox
  },
  computed: {
    title: function() {
      if (this.currentReport === 1)
        return this.$t('revenue.deposit')
      else if (this.currentReport === 2)
        return this.$t('revenue.backout')
      else if (this.currentReport === 3)
        return this.$t('revenue.non-operation')
      else if (this.currentReport === 4)
        return this.$t('revenue.retained')
      else
        return this.$t('revenue.operation')
    },
    legalEntityFilter: function() {
      let f = []
      for (let i = 0; i < this.legalEntity.length; i++) {
        let text = this.$i18n.locale === 'zh' ? this.legalEntity[i]['c_name'] : this.legalEntity[i]['e_name'],
          value = this.legalEntity[i].id
        f.push({
          'text': text,
          'value': value
        })
      }
      return f
    }
  },
  data: function() {
  return {
    dateRange: [moment().startOf('year').format('YYYY-MM-DD'), moment().endOf('year').format('YYYY-MM-DD')],
      account: null,
      currentReport: 1,
      currentData: null,
      activeTab: 1
  }
  },
  watch: {
    
  },
  methods: {
    filterHandler(value, row, column) {
      const property = column['property']
      return row[property] === value
    },
    showDetail(type) {
      console.log(type)
      this.currentReport = type
      switch (type) {
        case 1:
          this.currentData = this.account.detailed.dep
          break
        case 2:
          this.currentData = this.account.detailed.bak
          break
        case 3:
          this.currentData = this.account.detailed.nrev
          break
        case 5:
          this.currentData = this.account.detailed.rev
          break
      }
      
    },
    filterList: function() {
      
    },
    loadData: function() {
      let that = this,
          userId = localStorage.getItem('token'),
          loading = Loading.service({ fullscreen: true })

    this.$http.get(this.API3_PREFIX + 'revenue_account?userId=' + userId).then(function (response) {
    that.account = response.data
    that.$nextTick(() => {
      loading.close()
    })
      }).catch(function (error) {
    console.log(error)
    that.$nextTick(() => {
      loading.close()
    })
      })
    }
  },
  created: function() {
    this.loadData()
  }
}
</script>